<!--
	This is the tables page, it uses the dashboard layout in:
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <a-tabs v-model="activeKey">
      <a-tab-pane key="1" tab="密码安全">
        <updatePassword> </updatePassword>
      </a-tab-pane>
      <a-tab-pane key="2" tab="机器人配置" force-render>
        <a-card :bordered="false" class="dashboard-bar-chart">
          <div class="steps_box">
            <div class="steps_item">
              <div class="steps_dot">
                <div class="steps_dot_text">1</div>
                <div class="steps_line"></div>
              </div>
              <div class="steps_text">企业微信创建一个内部群</div>
            </div>
            <div class="steps_item">
              <div class="steps_dot">
                <div class="steps_dot_text">2</div>
                <div class="steps_line"></div>
              </div>
              <div class="steps_text" style="align-items: flex-start">
                <div style="margin-right: 5px">
                  创建企微机器人（群界面一>右上角"。" >机器人 > 添加机器人
                  一>输入"流水报告"）
                </div>
                <div
                  style="color: #1890ff; flex-shrink: 0; cursor: pointer"
                  @click="previewOpen(1)"
                >
                  查看示例
                </div>
                <!-- <img style="height: 100px" src="@/assets/step1.jpg" /> -->
              </div>
            </div>
            <div class="steps_item">
              <div class="steps_dot">
                <div class="steps_dot_text">3</div>
                <div class="steps_line"></div>
              </div>
              <div class="steps_text">
                <div style="margin-right: 5px">复制机器人链接</div>
                <div
                  style="color: #1890ff; flex-shrink: 0; cursor: pointer"
                  @click="previewOpen(2)"
                >
                  查看示例
                </div>
              </div>
            </div>
            <div class="steps_item">
              <div class="steps_dot">
                <div class="steps_dot_text">4</div>
                <div class="steps_line"></div>
              </div>
              <div class="steps_text">
                粘贴至此处，<a-input
                  style="width: 300px; margin-right: 5px"
                  v-model="linkSrc"
                  placeholder="请粘贴机器人链接(webHook)"
                />
                <a-button @click="save"  type="primary"> 保存 </a-button>
              </div>
            </div>
            <div class="steps_item">
              <div class="steps_dot">
                <div class="steps_dot_text">5</div>
                <!-- <div class="steps_line"></div> -->
              </div>
              <div class="steps_text">配置完成</div>
            </div>
          </div>
        </a-card>
      </a-tab-pane>
      <a-tab-pane key="4" tab="开发设置">
        <devSettings :userInfo="userInfo"> </devSettings>
      </a-tab-pane>
      <a-tab-pane key="3" tab="认证资料">
        <a-card :bordered="false" class="dashboard-bar-chart">
          <company></company>
        </a-card>
      </a-tab-pane>
    </a-tabs>

    <a-modal
      width="80vw"
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
    >
      <div
        style="
          width: 75vw;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <img v-if="urlType == 1" style="width: 100%" src="@/assets/step1.jpg" />
        <img v-if="urlType == 2" style="width: 100%" src="@/assets/step2.jpg" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import updatePassword from "./commponents/updatePassword.vue";
import company from "./commponents/company.vue";
import devSettings from "./commponents/devSettings.vue";
import { saveWebhookurl } from "@/api/setting";
export default {
  components: {
    updatePassword,
    company,
    devSettings,
  },
  data() {
    return {
      activeKey: "1",
      previewVisible: false,
      linkSrc: "",
      urlType: 1,
      userInfo: {},
    };
  },
  watch: {
    '$route.query.tab': {
      handler(newVal) {
        if (newVal === 'auth') {
          this.activeKey = "3";
        }
      },
      immediate: true
    }
  },
  mounted() {
    let userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      if (this.userInfo.wxWebHookUrl) this.linkSrc = this.userInfo.wxWebHookUrl;
    }
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    previewOpen(type) {
      this.urlType = type;
      this.previewVisible = true;
    },
    save() {
      if (!this.linkSrc) {
        this.$message.warning("请输入链接");
        return;
      }
      saveWebhookurl({ wxWebHookUrl: this.linkSrc }).then((res) => {
        this.$message.success("保存成功");
        // this.linkSrc = "";
        this.$store.dispatch("user/getInfo").then((res1) => {
          this.userInfo = res1;
          this.linkSrc = this.userInfo.wxWebHookUrl;
          console.log(res1);
        });
        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss">
.steps_box {
  .steps_item {
    display: flex;
    align-items: center;
    margin-bottom: 79px;
    .steps_dot {
      position: relative;
      color: #0091fb;
      border-radius: 50%;
      border: 1px solid #0091fb;
      text-align: center;
      line-height: 50px;
      width: 50px;
      height: 50px;
      .steps_dot_text {
        line-height: 50px;
        width: 50px;
        height: 50px;
      }
      .steps_line {
        position: absolute;
        bottom: -80px;
        left: 24px;
        background: #0091fb;
        width: 2px;
        height: 80px;
      }
    }
    .steps_text {
      display: flex;
      align-items: center;
      margin-left: 10px;
      color: #000;
      font-size: 14px;
      max-width: 500px;
      height: 50px;
    }
  }
}
</style>
